module.exports = __webpack_public_path__ + "img/if.d5ad042e.jpg";